import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { Theme } from '@mui/material/styles/createTheme';
import Grid from '@mui/material/Grid';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { cond, equals, T } from 'ramda';
import USPhoneNumber from 'src/components/USPhoneNumber/USPhoneNumber';
import getAPIErrorsFor from 'src/utilities/getAPIErrorFor';
import EditableTextField from 'src/components/Profile/FormField/EditableTextField';
import { getFormatters } from 'src/features/core/ChatEngine/Formatters/formatters';
import { PHONE_NUMBER_TEXT } from 'src/features/core/Intents/intentConstants';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    item: {},
    label: {
      color: theme.palette.basic.grey,
      fontSize: '12px',
      fontWeight: 400,
    },
    container: {
      display: 'flex',
      alignItems: 'center',
    },
    value: {
      flexGrow: 1,
      fontSize: '14px',
      fontWeight: 600,
      [theme.breakpoints.down('sm')]: {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden'
      },
    },
    phoneField: {
      display: 'flex',
      flexDirection: 'column',
      fontSize: '14px',
      width: '100%',

      '& input': {
        minWidth: 'initial !important',
        width: '100% !important',
      },
    },
    valueContainer: {
      flexBasis: 'auto',
      maxWidth: '100%'
    }
  })
);

interface Props {
  value?: string;
  isEdit: boolean;
  type: string;
  name?: string;
  updateErrors?: any;
  onClick?: () => void;
  onChange?: (value: any) => void;
  onClose?: () => void;
  onPasswordChange?: (e: string) => void;
}

const SummaryInput: React.FC<Props> = (props: Props) => {
  const {
    onChange,
    value,
    isEdit,
    type,
    name,
    updateErrors,
    onPasswordChange,
  } = props;
  const classes = useStyles();
  const hasErrorFor = getAPIErrorsFor(
    {
      password: 'Password',
    },
    updateErrors
  );


  const updvalue = cond([
    [
      equals(PHONE_NUMBER_TEXT),
      () => getFormatters('PHONE_NUMBER_FORMATTER')(value),
    ],

    [T, () => value],
  ])(type);


  const passwordError = hasErrorFor('password');

  return (
    <Box className={classes.item}>
      <Box className={classes.container}>
        {isEdit ? (
          <>
            {equals(type, PHONE_NUMBER_TEXT) ? (
              <Box className={classes.phoneField}>
                <USPhoneNumber onChange={onChange} value={value} />
              </Box>
            ) : equals(type, 'password') ? (
              <div style={{ width: '100%' }}>
                <EditableTextField
                  placeholder=""
                  inputExistingText={value}
                  onChange={onPasswordChange}
                  inputTypeAttribute={'password'}
                  validateError={passwordError}
                />
              </div>
            ) : (
              <TextField
                value={value}
                onChange={onChange}
                type={type}
                name={name}
                InputProps={{
                  sx: { fontSize: '14px' },
                }}
              />
            )}
          </>
        ) : (
          <>
            {equals(type, 'password') ? (
              <Grid container w-100>
                <Grid item xs={9} className={classes.valueContainer} display="flex" alignItems="center">
                  <Typography
                    variant="caption"
                    component="p"
                    fontWeight="700"
                    color="textSecondary"
                    className={classes.value}
                  >
                    **********
                  </Typography>
                </Grid>
              </Grid>
            ) : (
              <Grid container w-100>
                <Grid item xs={9} className={classes.valueContainer} display="flex" alignItems="center">
                  <Typography className={classes.value}>{updvalue}</Typography>
                </Grid>
              </Grid>
            )}
          </>
        )}
      </Box>
    </Box>
  );
};

export default SummaryInput;
